import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { TourUsageTracker } from 'ui-shepherd-tracker/usageTracker';
import { getStepId } from './tourTransformer';
import { getTourStepContentOverrides } from '../util/tourStorage';
import { jsx as _jsx } from "react/jsx-runtime";
let tourUsageTracker;

/**
 * Given a tour, this function will populate that tour with copy given that the copy is formatted correctly.
 * @param {tourConfig} tour
 */
export const populateTourWithCopy = tour => {
  const {
    alias,
    i18nPrefix
  } = tour;
  if (tour.recommendNextTour) {
    tour.recommendNextTour.title = I18n.text(`onboarding-tours-${i18nPrefix}.recommendNextTour.title`);
    tour.recommendNextTour.text = I18n.text(`onboarding-tours-${i18nPrefix}.recommendNextTour.text`);
    tour.recommendNextTour.cta = I18n.text(`onboarding-tours-${i18nPrefix}.recommendNextTour.cta`);
  }
  tour.steps.forEach((step, stepIndex) => {
    const stepNumber = stepIndex + 1;
    const tourStepContentOverrides = getTourStepContentOverrides(alias, `step ${stepNumber}`) || {};
    if (step.text === true) {
      step.text = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `onboarding-tours-${i18nPrefix}.step${stepNumber}.text`,
        options: tourStepContentOverrides.textOptions
      });
    }
    if (step.externalStepLink) {
      step.externalStepComponent = /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: step.externalStepLink,
        onClick: () => {
          if (!tourUsageTracker) {
            tourUsageTracker = new TourUsageTracker('onboarding-tours');
          }
          tourUsageTracker.trackTourClickExternalStepLink(tour.alias, getStepId(stepIndex));
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `onboarding-tours-${i18nPrefix}.step${stepNumber}.externalStepLink`
        })
      });
    }
    if (step.title === true) {
      step.title = I18n.text(`onboarding-tours-${i18nPrefix}.step${stepNumber}.title`, tourStepContentOverrides.titleOptions);
    }
    if (step.actionText === true) {
      step.actionText = I18n.text(`onboarding-tours-${i18nPrefix}.step${stepNumber}.actionText`);
    }
    if (step.buttons) {
      step.buttons.forEach((button, buttonIndex) => {
        const buttonNumber = buttonIndex + 1;
        if (button.text === true) {
          button.text = I18n.text(`onboarding-tours-${i18nPrefix}.step${stepNumber}.button${buttonNumber}`);
        } else if (typeof button.commonText === 'string') {
          button.text = I18n.text(`onboarding-tours-common.button.${button.commonText}`);
        }
      });
    }
  });
  return tour;
};